module.exports = __webpack_public_path__ + "media/preview/recruitment@2x-06b315c0.png";